var _ellipse, _ellipse2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _rect9, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIlVerifyEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 200,
    fill: "none",
    viewBox: "0 0 308 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.651,
    cy: 86.347,
    fill: "#FAD2BC",
    rx: 4.651,
    ry: 4.646
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.764,
    cy: 195.646,
    fill: "#FAD2BC",
    rx: 4.362,
    ry: 4.354
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07735",
    strokeWidth: 3,
    d: "M49.917 168.45c0 3.567-2.899 6.464-6.48 6.464-3.582 0-6.48-2.897-6.48-6.464 0-3.568 2.898-6.465 6.48-6.465 3.581 0 6.48 2.897 6.48 6.465z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#EE5F10",
    rx: 1.162,
    transform: "rotate(-44.944 46.7 -62.574)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#EE5F10",
    rx: 1.162,
    transform: "rotate(-44.944 63.201 -69.438)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#EE5F10",
    rx: 1.162,
    transform: "rotate(44.978 20.245 93.544)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.325,
    height: 6.392,
    fill: "#EE5F10",
    rx: 1.162,
    transform: "rotate(44.944 3.73 86.753)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.395,
    height: 6.154,
    x: 297.479,
    y: 87.339,
    fill: "#EE5F10",
    rx: 1.197
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.395,
    height: 6.154,
    x: 297.479,
    y: 97.909,
    fill: "#EE5F10",
    rx: 1.197
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.238,
    height: 6.586,
    x: 307.907,
    y: 94.787,
    fill: "#EE5F10",
    rx: 1.119,
    transform: "rotate(90 307.907 94.787)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.238,
    height: 6.586,
    x: 295.888,
    y: 94.787,
    fill: "#EE5F10",
    rx: 1.119,
    transform: "rotate(90 295.888 94.787)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD2BC",
    stroke: "#F07735",
    strokeWidth: 2,
    d: "M244.664 176.146V79.694c0-.36-.193-.692-.506-.87l-81.266-46.18-84.86 46.196c-.322.175-.522.512-.522.878v96.428c0 1.104.896 2 2 2h163.154c1.104 0 2-.896 2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#EBEFF5",
    strokeWidth: 0.168,
    d: "M218.916 30.897c0-5.515 4.436-10.085 10.26-11.004H113.264c-6.775 0-12.251 4.934-12.251 11.004v135.769h117.948V47.573h-.045V30.897z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 116.498,
    height: 128.627,
    x: 101.77,
    y: 13.13,
    fill: "#fff",
    stroke: "#F28C54",
    strokeWidth: 2,
    rx: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E1",
    stroke: "#F07735",
    strokeWidth: 2,
    d: "M160.47 153.448l-.673.594-.663-.606-79.949-73.124c-.642-.587-1.675-.132-1.675.738v95.096c0 1.104.896 2 2 2h163.154c1.104 0 2-.896 2-2V81.407c0-.86-1.016-1.32-1.662-.75l-82.532 72.791z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F6",
    stroke: "#F07735",
    strokeWidth: 2,
    d: "M243.758 177.33l-.577.816-76.797-54.331c-2.746-1.943-6.414-1.961-9.178-.044l-78.431 54.375H243.18l.577-.816z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2E7FB",
    fillRule: "evenodd",
    d: "M121.425 104.98h76.899c1.994 0 3.626 1.534 3.626 3.41 0 1.875-1.632 3.41-3.626 3.41h-76.899c-1.994 0-3.626-1.535-3.626-3.41 0-1.876 1.632-3.41 3.626-3.41zm0-31.124h76.899c1.994 0 3.626 1.535 3.626 3.41 0 1.876-1.632 3.41-3.626 3.41h-76.899c-1.994 0-3.626-1.534-3.626-3.41 0-1.875 1.632-3.41 3.626-3.41zm0-15.672h29.742c1.994 0 3.628 1.534 3.628 3.41 0 1.875-1.634 3.41-3.628 3.41h-29.742c-1.994 0-3.626-1.535-3.626-3.41 0-1.876 1.632-3.41 3.626-3.41zm0 31.234h76.899c1.994 0 3.626 1.534 3.626 3.41 0 1.876-1.632 3.41-3.626 3.41h-76.899c-1.994 0-3.626-1.534-3.626-3.41 0-1.876 1.632-3.41 3.626-3.41z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M199.427 56.661h4.959c-1.546 3.165-3.924 5.64-7.14 7.433-3.666 2.055-8.146 3.086-13.429 3.086-5.116 0-9.527-.865-13.247-2.594-3.722-1.737-6.488-4.291-8.299-7.663-1.815-3.379-2.719-7.052-2.719-11.034 0-4.363 1.03-8.424 3.095-12.192 2.052-3.76 4.878-6.584 8.454-8.472 3.577-1.888 7.669-2.832 12.271-2.832 3.905 0 7.378.762 10.408 2.277 3.038 1.522 5.363 3.68 6.966 6.48 1.603 2.8 2.403 5.855 2.403 9.17 0 3.959-1.213 7.528-3.648 10.725-3.048 4.03-6.958 6.044-11.725 6.044-1.284 0-2.253-.222-2.905-.666-.649-.452-1.077-1.102-1.299-1.967-1.825 1.753-3.935 2.633-6.316 2.633-2.571 0-4.702-.888-6.402-2.657-1.697-1.777-2.546-4.132-2.546-7.076 0-3.64 1.022-6.956 3.062-9.962 2.483-3.658 5.657-5.482 9.53-5.482 2.751 0 4.789 1.055 6.098 3.165l.58-2.594h6.131l-3.515 16.642c-.215 1.056-.324 1.737-.324 2.047 0 .38.087.675.267.865.178.198.39.293.637.293.746 0 1.705-.452 2.888-1.348 1.578-1.174 2.855-2.76 3.831-4.736.975-1.983 1.467-4.038 1.467-6.164 0-3.807-1.381-6.996-4.132-9.558-2.762-2.563-6.607-3.848-11.55-3.848-4.196 0-7.76.857-10.677 2.57-2.92 1.722-5.116 4.133-6.593 7.251-1.482 3.11-2.22 6.354-2.22 9.725 0 3.276.825 6.25 2.475 8.94 1.65 2.69 3.966 4.648 6.948 5.886 2.973 1.23 6.387 1.848 10.233 1.848 3.695 0 6.883-.523 9.544-1.562 2.665-1.04 4.814-2.594 6.439-4.673zm-25.073-9.55c0 1.967.395 3.419 1.188 4.347.803.928 1.786 1.396 2.962 1.396.879 0 1.702-.214 2.472-.65.588-.31 1.168-.802 1.739-1.468.825-.944 1.531-2.317 2.127-4.133.595-1.809.886-3.498.886-5.069 0-1.745-.405-3.094-1.212-4.03-.818-.936-1.841-1.404-3.071-1.404-1.333 0-2.563.516-3.687 1.547-1.129 1.031-1.976 2.499-2.547 4.403-.573 1.903-.857 3.593-.857 5.06",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2E7FB",
    fillRule: "evenodd",
    d: "M128.523 29.931c5.702 0 10.322 4.622 10.322 10.323 0 5.7-4.62 10.322-10.322 10.322-5.703 0-10.323-4.622-10.323-10.322 0-5.701 4.62-10.323 10.323-10.323z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIlVerifyEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/il_verify_email.920e13d5.svg";
export { ForwardRef as ReactComponent };